















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import { storePasien } from "@/store/modules/pasien";
import { tagIndicatorByRm } from "@/utils/pasienTag";
import { labelShiftOrderGizi } from "@/constants/gizi";
import { PasienTagByRm } from "@/types/daftarPasienPenunjang";
import { ModeDaftarPasienGizi, PasienGiziRow } from "@/types/orderGizi";

@Component({
  components: { PasienMultiWarningIndicator }
})
export default class CardListPasienGizi extends Vue {
  @Prop({ type: String, default: "utama" }) readonly mode!: ModeDaftarPasienGizi;
  @Prop({ type: Array, default: () => [] }) readonly items!: PasienGiziRow[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: "Daftar Pasien" }) readonly judul!: string;
  @Prop({ type: Object, default: () => ({}) }) readonly pasienTagByRm!: PasienTagByRm;

  get headers() {
    const awal = [
      { text: "No. RM", value: "rm", width: "90" },
      { text: "Nama Pasien", value: "nama" },
      { text: "", value: "indikator", width: "32" }
    ];
    const aksi = { text: "", value: "aksi", align: "end", width: "100" };

    if (this.mode === "order") {
      return [
        ...awal,
        { text: "Bangsal", value: "unit_nama" },
        { text: "Ruang", value: "ruang" },
        { text: "Tgl Masuk", value: "tanggal", width: "100" },
        { text: "DPJP", value: "dokter_nama" },
        { text: "Diit", value: "diit" },
        { text: "Petugas Gizi", value: "petugas_gizi" },
        aksi
      ];
    }

    return [
      ...awal,
      { text: "Jam", value: "jam", width: "70" },
      { text: "Ruang / Klinik Asal", value: "unit_nama" },
      { text: "DPJP", value: "dokter_nama" },
      { text: "Jaminan", value: "cara_bayar" },
      aksi
    ];
  }

  get tagIndicatorByRm(): Record<string, string[]> {
    return tagIndicatorByRm(
      this.pasienTagByRm,
      storePasien.pasientTagAttribute
    );
  }

  jkUmur(item: PasienGiziRow): string {
    return [item.sex, item.umur].filter(v => !!v).join(" · ");
  }

  formatTanggal(tanggal: string | null | undefined): string {
    if (!tanggal || tanggal.length < 10) return "-";
    const [y, m, d] = tanggal.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }

  labelShift(shift: string): string {
    return labelShiftOrderGizi(shift);
  }
}
